export const REGISTER_SERVICE_SERVICE_SELECTION = 'REGISTER_SERVICE-SERVICE_SELECTION';
export const REGISTER_SERVICE_DATA_CREATE_AT = 'REGISTER_SERVICE_DATA_CREATE_AT';
